export default __webpack_public_path__ + "static/media/Ellipse9.9ead8363.png";